import React, { Component } from 'react';

class SingleSkill extends Component {
    render() {
        return (
            <div>
                <div className="mt-4">
                    <div style={{background:'#1d293a'}} className="progress-box text-white p-3 rounded">
                        <div className="text d-flex">
                        <div className="col-10">
                        <h5>{this.props.skillName}</h5>
                        </div>
                        <div className="col-2">
                        <p style={{textAlign:'right',fontWeight:'500'}}>{this.props.skillPer}</p>
                        </div>
                        </div>
                        <div style={{height:'10px',background:'#111a28'}} className="progress">
                        <div className="progress-bar" role="progressbar" style={this.props.width}></div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SingleSkill;